import type { FormLocale } from '@jlg-website/shared';
import { TOTAL_STEPS, stepTitles } from './constants';
import { textFor } from '../shared/copy';

type StepProgressProps = {
  step: number;
  locale: FormLocale;
};

export function StepProgress({ step, locale }: StepProgressProps) {
  const titles = stepTitles[locale] ?? stepTitles.en;
  const stepLabel = textFor(locale, 'stepOf')
    .replace('{step}', String(step))
    .replace('{total}', String(TOTAL_STEPS));

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="text-base font-bold text-brand-text-button">{titles[step - 1]}</h2>
        <span className="text-[11px] font-medium uppercase tracking-wide text-gray-light">
          {stepLabel}
        </span>
      </div>

      <div
        className="h-1 w-full rounded-full bg-brand-muted-light"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={TOTAL_STEPS}
        aria-valuenow={step}
        aria-label={stepLabel}
      >
        <div
          className="h-full rounded-full bg-brand-primary transition-all duration-300"
          style={{ width: `${(step / TOTAL_STEPS) * 100}%` }}
        />
      </div>
    </div>
  );
}
